import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitLead = (payload) => axios.post(`${API}/leads`, payload);
